import { useTranslation } from 'next-i18next';
import { SortBy } from 'react-instantsearch';
import { getIndex } from '@utils/algolia/analytics';
import { getPriceSortSuffix } from '@utils/algolia/priceContext';
import { usePriceGroupKey } from '@hooks/usePriceGroupKey';

import styles from './SortResults.module.scss';

export const SortResults = ({ locale = 'en' }) => {
  const { t } = useTranslation(['searchResults']);

  // Price sort uses the replica that ranks on this customer's effective price
  // (guest keeps `_price_*`; other tiers use `_price_<tier>_*`).
  const priceSortSuffix = getPriceSortSuffix(usePriceGroupKey());

  const sortByPopular = getIndex(locale);
  const sortByPriceAsc = getIndex(locale, `_price${priceSortSuffix}_asc`);
  const sortByPriceDesc = getIndex(locale, `_price${priceSortSuffix}_desc`);
  const sortByRating = getIndex(locale, '_reviewscore_desc');

  return (
    <>
      <label className={styles.sortByHeader} htmlFor="sort-by">
        {t('search.sortby.title')}
      </label>
      <SortBy
        id="sort-by"
        classNames={{
          root: styles.sortByRoot,
          select: styles.sortBySelect,
          option: styles.sortByOption,
        }}
        items={[
          { label: t('search.sortby.popular'), value: sortByPopular },
          {
            label: t('search.sortby.price.asc'),
            value: sortByPriceAsc,
          },
          {
            label: t('search.sortby.price.desc'),
            value: sortByPriceDesc,
          },
          {
            label: t('search.sortby.rating'),
            value: sortByRating,
          },
        ]}
      />
    </>
  );
};
